module.exports = __webpack_public_path__ + "img/logo-cer-06.aa2b0acc.png";